import { availableFiltersBySource, createFiltersFn } from './filtration';
import type {
  DataValue,
  ProviderType,
  SourceValue,
  UserValue
} from './sources';
import {
  createFacebookPageProvider,
  createInstagramAccountProvider,
  createInstagramHashtagProvider,
  createInstagramMentionsProvider,
  createLegacyInstagramBusinessAccountProvider,
  createLegacyInstagramPersonalAccountProvider,
  createLegacyTwitterHashtagProvider,
  createLegacyTwitterProfileProvider,
  createLinkedinSourceProvider,
  createPinterestDataProvider,
  createRssFileProvider,
  createTiktokSourceProvider,
  createTumblrDataProvider,
  createTwitterHashtagProvider,
  createTwitterProfileProvider,
  createVimeoDataProvider,
  createVkontaktePageProvider,
  createYoutubeSourceProvider
} from './sources';
import { getFiltersKey, getPostsLimit } from './utils';

const sourceProviderCreatorMapping = {
  instagramAccount: createInstagramAccountProvider,
  instagramMentions: createInstagramMentionsProvider,
  instagramHashtag: createInstagramHashtagProvider,
  legacyInstagramBusinessAccount: createLegacyInstagramBusinessAccountProvider,
  legacyInstagramPersonalAccount: createLegacyInstagramPersonalAccountProvider,
  facebookPage: createFacebookPageProvider,
  linkedinSource: createLinkedinSourceProvider,
  tumblrData: createTumblrDataProvider,
  twitterProfile: createTwitterProfileProvider,
  twitterHashtag: createTwitterHashtagProvider,
  legacyTwitterProfile: createLegacyTwitterProfileProvider,
  legacyTwitterHashtag: createLegacyTwitterHashtagProvider,
  pinterestProfile: createPinterestDataProvider,
  pinterestBoard: createPinterestDataProvider,
  vkontakteProfile: createVkontaktePageProvider,
  vkontakteGroup: createVkontaktePageProvider,
  vkontakteOwnProfile: createVkontaktePageProvider,
  vkontaktePublic: createVkontaktePageProvider,
  tiktokProfile: createTiktokSourceProvider,
  tiktokHashtag: createTiktokSourceProvider,
  rssFile: createRssFileProvider,
  vimeoUser: createVimeoDataProvider,
  vimeoChannel: createVimeoDataProvider,
  vimeoGroup: createVimeoDataProvider,
  vimeoShowcase: createVimeoDataProvider,
  vimeoSpecificVideo: createVimeoDataProvider,
  youtubeChannel: createYoutubeSourceProvider,
  youtubePlaylist: createYoutubeSourceProvider
};

export type FetcherType = ProviderType & {
  id: string;
  filter: {
    available: boolean;
    applyFilters: (data: DataValue[]) => DataValue[];
    sourcePostLimit: number | null;
  };
};

export function determineFetcher(
  source: SourceValue,
  globalKey: string[],
  widgetToken?: string,
  updateSourceAuthor?: (sourceId: string, author: UserValue) => void
): FetcherType | undefined {
  const { connectionType, filters } = source;

  if (!connectionType) {
    return undefined;
  }

  const createProvider = sourceProviderCreatorMapping[connectionType];

  if (!createProvider) {
    throw new Error(`Unknown source ${connectionType}`);
  }

  const availableFilters = availableFiltersBySource[connectionType];
  const filtersKey = getFiltersKey(filters);
  const postsLimit = getPostsLimit(source, filtersKey);

  // @ts-expect-error Есть трудности с правильной типизацией из-за неконсистентности источников
  const provider: ProviderType = createProvider(
    // @ts-expect-error Есть трудности с правильной типизацией из-за неконсистентности источников
    source,
    globalKey,
    filtersKey,
    widgetToken,
    updateSourceAuthor
  )!;

  return {
    ...provider,
    id: `${source.platform}-${source.id}`,
    filter: {
      available: !!postsLimit,
      applyFilters: createFiltersFn(source, availableFilters),
      sourcePostLimit: postsLimit
    }
  };
}
